'use client';

import { Minus, Plus } from '@untitledui/icons';
import { Button } from '@untitledui/react/components/base/buttons/button';

interface QuantityStepperProps {
  value: number;
  onChange: (value: number) => void;
  /** Nommé pour les lecteurs d'écran : « Ajouter un Ordinateur ». */
  itemLabel: string;
  min?: number;
  max?: number;
}

/** Sélecteur de quantité −/+ du mode « tout sélectionner, puis remplir ». */
export function QuantityStepper({ value, onChange, itemLabel, min = 0, max = 20 }: QuantityStepperProps) {
  return (
    <div className="flex items-center gap-2">
      <Button
        size="sm"
        color="secondary"
        iconLeading={Minus}
        isDisabled={value <= min}
        onClick={() => onChange(value - 1)}
        aria-label={`Retirer un ${itemLabel}`}
      />
      <span
        className="text-primary w-6 text-center text-sm font-semibold tabular-nums"
        aria-live="polite"
        aria-label={`${value} ${itemLabel}`}
      >
        {value}
      </span>
      <Button
        size="sm"
        color="secondary"
        iconLeading={Plus}
        isDisabled={value >= max}
        onClick={() => onChange(value + 1)}
        aria-label={`Ajouter un ${itemLabel}`}
      />
    </div>
  );
}
